import React from "react";
import SearchField from "react-search-field";

import "./styles.css";

function BarraDePesquisa({ setState = () => {} }) {
  return (
    <SearchField
      placeholder="Pesquisar..."
      class="react-search"
      onSearchClick={(value) => setState(value)}
      onEnter={(value) => setState(value)}
    />
  );
}

export default BarraDePesquisa;
